import React from "react";
import { Link, useLocation } from "react-router-dom";

const breadcrumbNameMap = {
  '/company': '企業情報',
  '/company/companyOverview': '会社概要',
  '/company/philosophy': '当社理念',
  '/company/organization': '組織図',
  '/businessContent': '事業内容',
  '/businessContent/minpaku': '民泊運営事業',
  '/businessContent/real-estate': '不動産事業',
  '/news': 'お知らせ',
  '/contact': 'お問合せ',
};

const Breadcrumb = ({ extra }) => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const breadcrumbItems = pathnames.map((_, index) => {
    const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
    return { path: routeTo, name: breadcrumbNameMap[routeTo] };
  });

  return (
    <nav className="text-gray-600 text-sm py-4 px-10">
      <Link to="/" className="text-blue-600 hover:underline">
        ホーム
      </Link>
      {breadcrumbItems.map((item, index) => (
        <span key={item.path}>
          {" > "}
          <Link to={item.path} className="text-blue-600 hover:underline">
            {item.name}
          </Link>
        </span>
      ))}
      {extra && (
        <span>
          <span className="text-gray-500">{extra}</span>
        </span>
      )}
    </nav>
  );
};

export default Breadcrumb;
